export const GATSBY_API_ROOT = process.env.GATSBY_API_ROOT;
export const GATSBY_ZENDESK_KEY = process.env.GATSBY_ZENDESK_KEY;
export const GATSBY_GOOGLE_CAPTCHA_KEY = process.env.GATSBY_GOOGLE_CAPTCHA_KEY;
export const GATSBY_ENVIROMENT = process.env.GATSBY_ENVIROMENT;
export const GATSBY_GOOGLE_MAPS_KEY = process.env.GATSBY_GOOGLE_MAPS_KEY;
export const GATSBY_FILTER_LOCATIONS_MIX_NEXT =
  process.env.GATSBY_FILTER_LOCATIONS_MIX_NEXT;
